import { render, staticRenderFns } from "./AnalysisBasic.vue?vue&type=template&id=3893a303&"
import script from "./AnalysisBasic.vue?vue&type=script&lang=js&"
export * from "./AnalysisBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports